<div class="container-fluid bg">
    <div class="row">
        <div class="col-lg-12 text-center">
            <h5 class="font-style" style="font-weight: 300; color: white;">© Copyright 2021 by EquinoxGroup. All right Reserved – Design By <a href="https://flexcall.it/">FlexCall</a>
            </h5>
        </div>
    </div>
</div>